/*******************************************************************************
* @ngdoc    object
* @module   csm.books.InitialSetup.types
* @name     csm.books.InitialSetup.types.type:AccountList
* @constructor
* @param {SetupAccount[]} List of SetupAccount objects.
*
* @description
* `AutoIDList` of `SetupAccount` objects.
*******************************************************************************/
/* @ngInject */ export function accountListFactory(AutoIDList) {
  function AccountList() {
    this.construct('AccountList', arguments);
  }

  AccountList.prototype = Object.defineProperties(
    Object.create(AutoIDList.prototype),
    {
      idProperty: { value: 'accountID' }
    }
  );

  return AccountList;
};
